import { Group } from '@/components/_common';
import { ReportQuotationCompany } from '@/core/domain/stock/Quotations/Quotations.types';
import { Card, Row, Col, Typography, Image } from 'antd';
import moment, { Moment } from 'moment';

interface Props {
  company?: ReportQuotationCompany;
  title?: string;
  date?: Moment;
}

const dateDefault = moment();

const ReportDocumentHeader: React.FC<Props> = ({ company, title, date }) => {
  return (
    <Card style={{ background: 'white', borderColor: '#d9d9d9' }}>
      <Row align="middle">
        <Col flex={1} className="reportQuotation-header-info">
          <Group gap={24}>
            {!!company?.logo && (
              <Image preview={false} src={company?.logo} width={80} />
            )}

            <div>
              {!!company?.name && (
                <Typography.Title level={3} className="m-0 p-0">
                  {company?.name}
                </Typography.Title>
              )}

              {!!title && (
                <Typography.Title level={4} className="m-0 p-0">
                  {title}
                </Typography.Title>
              )}
            </div>
          </Group>
        </Col>

        <Col className="reportQuotation-header-date">
          <big>
            <Row gutter={4} align="middle">
              <Col span={10} className="text-right">
                <strong>Emissão:</strong>
              </Col>
              <Col span={14} className="text-right">
                <span>{(date || dateDefault).format('DD/MM/YYYY')}</span>
              </Col>
            </Row>
            <Row gutter={2} align="middle">
              <Col span={10} className="text-right">
                <strong>Horário:</strong>
              </Col>
              <Col span={14} className="text-right">
                <span>{(date || dateDefault).format('HH:mm:ss')}</span>
              </Col>
            </Row>
          </big>
        </Col>
      </Row>
    </Card>
  );
};

export default ReportDocumentHeader;
